var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEyeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.16147 3.39486C7.43241 3.3548 7.71192 3.33331 7.99979 3.33331C11.4031 3.33331 13.6364 6.33654 14.3866 7.52453C14.4775 7.66831 14.5229 7.74021 14.5483 7.8511C14.5673 7.93437 14.5673 8.06576 14.5482 8.14903C14.5228 8.25991 14.4771 8.33228 14.3856 8.47702C14.1857 8.79341 13.881 9.23805 13.4772 9.72028M4.48239 4.47667C3.04101 5.45445 2.06248 6.8129 1.61358 7.5235C1.52237 7.66789 1.47676 7.74009 1.45134 7.85097C1.43224 7.93424 1.43224 8.06561 1.45132 8.14889C1.47673 8.25977 1.52213 8.33166 1.61293 8.47543C2.36321 9.66342 4.59645 12.6666 7.99979 12.6666C9.37206 12.6666 10.5541 12.1784 11.5254 11.5177",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2L14 14M6.58579 6.58579C6.22386 6.94772 6 7.44772 6 8C6 9.10457 6.89543 10 8 10C8.55228 10 9.05229 9.77614 9.41421 9.41421",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEyeOff);
export default __webpack_public_path__ + "static/media/IconEyeOff.3439306ebdd8fd580a9c8c97aa172d77.svg";
export { ForwardRef as ReactComponent };